import { Lock } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useNavigate } from 'react-router-dom';
import { PROTO } from '@/constants/testIds/healthspan';

export default function TierGateCTA({ title = 'Full technical summary is a Researcher feature', description = 'Upgrade to access the technical summary, references, and CSV export.' }) {
  const nav = useNavigate();
  return (
    <div data-testid={PROTO.tierLock} className="mt-4 rounded-[var(--radius-md)] border border-[color:rgba(212,175,55,0.45)] bg-[color:rgba(212,175,55,0.08)] p-4">
      <div className="flex items-start gap-2">
        <Lock className="h-4 w-4 mt-0.5 text-[color:var(--accent-gold)]" aria-hidden="true" />
        <div className="flex-1">
          <div className="text-sm font-semibold">{title}</div>
          <p className="mt-1 text-sm text-[color:var(--muted-fg)]">{description}</p>
          <Button size="sm" className="mt-3 bg-[color:var(--accent-gold)] text-[color:var(--brand-primary)] hover:opacity-90" onClick={() => nav('/pricing')}>
            View Researcher tier
          </Button>
        </div>
      </div>
    </div>
  );
}
